const birth =
{
    date      : 'Date: {0}' ,
    empty     : '-----',
    pattern   : 'DD MMMM YYYY' ,
    place     : 'Lieu: {0}' ,
    separator : ' - ' ,
    title     : 'Naissance'
};

export default birth ;